'use strict';

var _ = require('lodash');
var urlJoin = require('url-join');
var userEndpointMixin = require('./user-endpoint-mixin');
var { get, put, post } = require('./send-action');

function Preferences(options) {
  this._baseUrl = options.baseUrl;
}

Preferences.prototype.requestUrl = function(property) {
  property = property || '';
  return urlJoin(this._baseUrl, this._usersUrl, 'preferences', property, '/');
};

Preferences.prototype.get = function(property) {
  var uri = this.requestUrl(property);
  return get(uri);
};

Preferences.prototype.put = function(property, value) {
  var uri = this.requestUrl(property);
  var requestBody = { value: value };
  return put(uri, requestBody);
};

Preferences.prototype.update = function(userPreferences) {
  var uri = urlJoin(this._baseUrl, this._usersUrl, 'set-preferences/')
  var requestBody = Object.assign({}, userPreferences)
  return post(uri, requestBody);
};

_.assignIn(Preferences.prototype, userEndpointMixin);

module.exports = Preferences;
